//启用的功能
import enabled_features from "./enabled_features";
//面板上禁用的功能
import disabled_features from "./disabled_features";
//柱状图颜色
import studies_overrides from "./studies_overrides";
//主要配置
import overrides from "./overrides";
//设置初始化加载条样式
import loading_screen from "./loading_screen";

export default {
    enabled_features,
    disabled_features,
    studies_overrides,
    // overrides,
    loading_screen
}